import i18n from '@/plugins/i18n'
import Cookie from 'vue-cookie'

export default {
  setLanguage: (language) => {
    i18n.locale = language
    Cookie.set('USER_LANGUAGE', language)
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascript/language.js